import * as React from "react";
import UploadFiles from "./UploadFiles";

const agentForms=[{    
    label:'W9',
    name:'w9_form'
    },{
    label:'Payroll',
    name:'payroll_form'
    },{
    label:'CA',
    name:'ca_form'
    },{
    label:'IT Policy',
    name:'it_policy_form'
    },{
    label:'Trade Secrets',
    name:'trade_secrets_form'
    },
    {
    label:'Real Estate License',
    name:'re_license_form'
    }];
const employeeForms=[{
    label:'W4',
    name:'w4_form'
    },{
    label:'Payroll',
    name:'payroll_form'
    },{
    label:'CA',
    name:'ca_form'
    },{
    label:'IT Policy',
    name:'it_policy_form'
    },{
    label:'Trade Secrets',
    name:'trade_secrets_form'
    },
   {
    label:'Real Estate License',
    name:'re_license_form'
    }];

const TeamMemberUploadDocInfo = ({isDisabled, data, handleChangeInput, handleChangeFile, viewMode, deleted}) => {
    return (
        <div className="Team-member-info">            
            <div className="Team-member-info_column">
                <UploadFiles
                    classNames="Team-member-info_column_item"
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    initialFilesAmount={6}
                    maxFilesAmount={data.is_agent === "n"? employeeForms.length : agentForms.length}
                    items={data.is_agent === "n"? employeeForms : agentForms}
                    disabled={isDisabled}
                    handleChangeInput={handleChangeInput}
                />               
                
            </div>            
        </div>
    );
};

export default TeamMemberUploadDocInfo;
